import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1934107898/src/apps/fanychance/src/features/lottery/components/LotteryInfiniteList/LotteryInfiniteList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1934107898/src/apps/fanychance/src/features/lottery/components/LotteryListHeader/LotteryListHeader.tsx");
